import {Component, Input, OnChanges, SimpleChanges, OnInit} from '@angular/core';
import {GetDealerStatsService} from "./services/get-dealer-stats.service";
import {DealerStatsDto} from "../../../../auto-generated-server-dtos/adjuster/claim/dealer-stats/dealer-stats-dto";
import {ClaimDto} from "../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";
import * as feather from "feather-icons";

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrl: './stats.component.scss'
})
export class StatsComponent implements OnInit, OnChanges {

  @Input() claimDto: ClaimDto | null = null;
  public dealerStats: DealerStatsDto | null = null;
  public loading = true;
  public error = false;

  constructor(
    private getDealerStatsService: GetDealerStatsService
  ) {
  }

  ngOnInit() {
    feather.replace();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.claimDto && changes.claimDto.currentValue) {
      this.getDealerStatsService.GetDealerStats(this.claimDto!.claimId).subscribe({
        next: (dealerStats) => {
          this.dealerStats = dealerStats;
          this.loading = false;
        },
        error: (err) => {
          this.error = true;
          this.loading = false;
        }
      });
    }
  }
}
